export default "__VITE_ASSET__BWBGyE6p__"